import { SignInPage } from './pages/sign-in/sign-in.page';
import { ListaTopicPage } from './pages/lista-topic/lista-topic.page';
import { GifPromptPage } from './pages/gif-prompt/gif-prompt.page';
import { LanguagePage } from './pages/language/language.page';
import { WelcomePage } from './pages/welcome/welcome.page';
import { ChangeNamePage } from './pages/change-name/change-name.page';
import { ChangePassPage } from './pages/change-pass/change-pass.page';
import { DeleteUserPage } from './pages/delete-user/delete-user.page';

import { CoachMarksComponent } from './components/coach-marks/coach-marks.component';
import { LanguageComponent } from './components/language/language.component';
import { CanvasDrawingsComponent } from './components/canvas-drawings/canvas-drawings.component';
import { LoadingComponent } from './components/loading/loading.component';
import { FirebaseDbProvider } from './providers/firebase-db/firebase-db';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from '../environments/environment';
import { SharedModule } from './shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent,
    LanguageComponent,
    LanguagePage,
    CoachMarksComponent,
    WelcomePage,
    GifPromptPage,
    ChangeNamePage,
    ChangePassPage,
    DeleteUserPage,
    ListaTopicPage,
    SignInPage
  ],
  entryComponents: [
    LanguagePage,
    WelcomePage,
    GifPromptPage,
    ChangeNamePage,
    ChangePassPage,
    DeleteUserPage,
    ListaTopicPage,
    SignInPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.fireBaseConfig),
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    NgxChartsModule,
    NgxGraphModule,
    BrowserAnimationsModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    FirebaseDbProvider,
    LoadingComponent,
    CanvasDrawingsComponent,
    LanguageComponent,
    CoachMarksComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
